<template>
    <div v-if="repeaterBlocDto" class="row m-0 px-0 px-md-2 px-lg-3 px-xl-4">
        <div class="col-12 col-md-5 p-0 p-md-2 pb-1 align-self-center text-center">
            <img
                loading="lazy"
                alt=""
                class="img-fluid"
                :src="repeaterBlocDto.picture"
            >
        </div>
        <div class="col-12 col-md-7 p-0 p-md-2 align-self-center text-white">
            <h3 class="h4 mb-0" v-html="repeaterBlocDto.title" />
            <p>
                <span v-html="repeaterBlocDto.description" />
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RepeaterBlock',
    props: {
      repeaterBlocDto: {
        type: Object,
        required: false,
        default: null
    }
  }
}
</script>
